import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import sLay from 'styles/modules/layout.scss'
import { Row, Col } from 'components/Layout'
import cn from 'classnames'
import s from './CompareList.scss'
import { range } from 'lodash'
import IconStar from 'components/Icons/Star'
import sText from 'components/Text/Text.scss'

const ListItem = ({ item }) => <div className={s.item}>{item}</div>

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
    sectionWidth={props.sectionWidth}
    style={{ textAlign: 'center' }}
    pattern={props.pattern}
  >
    <Markdown text={props.text} color={props.color} />
    <br />
    <br />
    <br />
    <Row className={cn(sLay['layout-row'], 'lg')}>
      <Col className={cn(sLay['flex-50'], 'lg')}>
        <div className={cn(s.title1, sText.heading2)}>{props.title1}</div>
        <div>
          {props.list1.map(item => (
            <ListItem item={item} key={item} />
          ))}
        </div>
      </Col>
      <Col className={cn(sLay['flex-50'], 'lg', s.colRight)}>
        <div className={s.vs}>vs.</div>
        <div className={cn(s.title2, sText.heading2)}>{props.title2}</div>
        <div>
          {props.list2.map(item => (
            <ListItem item={item} key={item} />
          ))}
        </div>
      </Col>
    </Row>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/CompareList/CompareList.jsx